import React from "react";
import { AppLayout } from "../components/layout";
import PortalSettings from "../components/features/portal/PortalSettings";
import { useIsProCloudPlan, useUserStore } from "../store/userStore";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui";

const PortalSettingsPage: React.FC = () => {
  const { properties } = useUserStore();
  const isProCloudPlan = useIsProCloudPlan();
  const breadcrumbs = [
    // { title: 'Dashboard', href: 'dashboard' },
    { title: 'Guide Branding', isCurrentPage: true }
  ];
  const portalSettings = properties?.portal?.settings;
  //const isProCloudPlan = properties?.subscription?.plan === 'pro-cloud';

  return (
    <AppLayout showSidebar={true} breadcrumbs={breadcrumbs}>
      <div className="p-4 min-w-[650px] max-w-[750px] mx-auto">
        <div className="mb-3 ">
          <h1 className="text-xl font-bold text-foreground">Guides Branding</h1>
          <Alert variant="info" className="mt-3 mb-3">
            <AlertDescription>
              These settings only apply to guides that are shared directly using a link.
            </AlertDescription>
          </Alert>
        </div>
        
        <PortalSettings 
          settings={portalSettings}
          isProCloudPlan={isProCloudPlan}
          context="guide"
        />
      </div>
    </AppLayout>
  );
};

export default PortalSettingsPage;
